import { Injectable } from '@angular/core';
import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

@Injectable({
  providedIn: 'root',
})
export class TooltipConfigService implements MatTooltipDefaultOptions {
  // Define your default tooltip class here
  tooltipClass = 'primary-tooltip';
  showDelay = 300;
  hideDelay = 300;
  touchendHideDelay = 300;
}
